import React, { Fragment, useEffect, useRef, useState } from "react";
import EADialog from "./EADialog";
import EAButton from "./EAButton";
import { isApiCancel, useHttp } from "../services/HttpService";
import { logger } from "../services/LogService";
import EATextField from "./EATextField";
import { buildRequiredMessage } from "../utils/Validator";

export default function EAFileUploadDialog({ open, label, testId, uploadPath, onSuccess, onError, onClose, withBezeichnung = true }) {
    const maxFileSizeInMB = 100;
    const inputFile = useRef(null);
    const [{ loading: fileUploading }, uploadFile] = useHttp(
        {
            url: uploadPath,
            method: "POST",
        },
        { manual: true }
    );
    const [bezeichnung, setBezeichnung] = useState();
    const [datei, setDatei] = useState();
    const [error, setError] = useState({});

    useEffect(() => {
        if (open === false) {
            setBezeichnung("");
            setDatei(null);
        }
    }, [open, setBezeichnung, setDatei]);

    function handleuploadFile() {
        const newErrors = {};
        if (withBezeichnung && !bezeichnung) {
            newErrors.bezeichnung = buildRequiredMessage();
        }
        if (!datei) {
            newErrors.datei = "Sie müssen eine Datei hochladen!";
        } else if (datei.size > maxFileSizeInMB * 1024 * 1024) {
            newErrors.datei = "Die Datei darf maximal " + maxFileSizeInMB + " MB groß sein.";
        }
        setError(newErrors);
        if (Object.keys(newErrors).length !== 0) {
            return;
        }
        const formData = new FormData();
        formData.append("file", datei, datei.name);
        if (withBezeichnung) {
            formData.append("bezeichnung", bezeichnung);
        }
        uploadFile({ data: formData })
            .then(() => {
                onSuccess();
            })
            .catch((err) => {
                if (isApiCancel(err)) {
                    return;
                }
                if (err.response) {
                    if (err.response.data?.validationErrors) {
                        setError(err.response.data.validationErrors);
                    } else if (err.response.status === 400 && err.response.data) {
                        onError(err.response.data);
                    } else {
                        logger.error(err.response);
                        onError();
                    }
                } else {
                    logger.error(err);
                    onError();
                }
            });
    }

    function handleUploadClick() {
        inputFile.current.click();
    }

    return (
        <EADialog
            open={open}
            testId={testId}
            closeFunction={onClose}
            content={
                <div className="gridl" style={{ gridTemplateColumns: "400px max-content" }}>
                    {withBezeichnung && (
                        <EATextField
                            label="Bezeichnung"
                            id="dateiBezeichnung"
                            value={bezeichnung}
                            onChange={(e) => setBezeichnung(e.target.value)}
                            error={error.bezeichnung}
                            style={{ gridColumn: "span 2" }}
                        />
                    )}
                    <EATextField id="dateiName" disabled={true} value={datei?.name ? datei.name : ""} error={error.datei} />
                    <Fragment>
                        <input type="file" onChange={(e) => setDatei(e.target.files[0])} ref={inputFile} style={{ display: "none" }} />
                        <EAButton
                            id="fileUploadButton"
                            label="Datei auswählen"
                            onClick={handleUploadClick}
                            disabled={fileUploading || !uploadPath}
                            loading={fileUploading || !uploadPath}
                        />
                    </Fragment>
                </div>
            }
            titleChildren={label}
            buttons={
                <EAButton
                    id="submitUpload"
                    label="Datei hochladen"
                    disabled={fileUploading}
                    loading={fileUploading}
                    onClick={handleuploadFile}
                />
            }
        />
    );
}
